module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/filetypes/office powerpoint icon-b110cf3d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/filetypes/office powerpoint icon.svg
// module id = ./app/web/src/assets/filetypes/office powerpoint icon.svg
// module chunks = 0